import React, { useState, } from 'react';
import LinkIcon from '@material-ui/icons/Link';
import PropTypes from 'prop-types';
import useStyles from './SearchIntelligence.style';

const MobileAirtable = ({orderRow}) => {
  const [fullView, setFullview] = useState(false);
  const classes = useStyles();
  const row = orderRow.filter(obj => 'Tittle' in obj)[0];
  const placements = orderRow.filter(obj => !('Tittle' in obj));


  const handleClick = () => {
    setFullview(!fullView);
  };

  const capitalization = (str) => str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();

  return (
      <>
      <div
          className={classes.mobileCard}
          key={row.Tittle}
          onClick={handleClick}
          role="presentation"
          aria-label="default box"
      >
          {fullView? 
          (<>
              <div style={{ display: "flex", flexDirection: 'column'}}>
                <div className={classes.flexLine}>
                  <div className={classes.columnTitle}>Campaign Name</div>
                  <div className={classes.columnValue}>{row.Tittle? capitalization(row.Tittle): "-"}</div>
                </div>
                <div className={classes.flexLine}>
                  <div className={classes.columnTitle}>Date</div>
                  <div className={classes.columnValue}>{row["Task Started"] && !Number.isNaN(new Date(row["Task Started"]).getTime()) ? `${new Date(row["Task Started"]).toLocaleString('en-US', {
                      year: 'numeric',
                      month: 'short',
                      day: 'numeric',
                  })}` : "-"}</div>
                </div>
                <div className={classes.flexLine}>
                  <div className={classes.columnTitle}>Status</div>
                  <div className={classes.columnValue}>{row.Status}</div>
                </div>
              </div>
              <div
              style={{ background: '#00B4E0', height: '1px', width: '100%', margin: '10px 0' }}
              />
              {placements.map((placement) => (
                  <React.Fragment key={placement.link}>
                    <div style={{ display: "flex", gap: '10px', color: '#00B5E2', borderBottom: '1px solid lightGrey', padding:'9px 5px 1px'}}>
                      <LinkIcon style={{ width: "14px"}} />
                      <a 
                        href={placement.URL} 
                        style={{ 
                          textDecoration: 'none', 
                          color: '#00B5E2',
                          maxWidth: '70vw',
                        }} 
                        target="_blank"
                        rel="noreferrer">
                        <div className={classes.linkEllipsis} style={{maxWidth:'100vw'}}>
                          {placement.URL}
                        </div>
                      </a>
                    </div>
                  </React.Fragment>
                  )
              )}
          </>):
          (<div className={classes.flexLineDefault}>
              <div style={{ width: '20%', userSelect: 'none' }}>{row["Task Started"] && !Number.isNaN(new Date(row["Task Started"]).getTime()) ? `${new Date(row["Task Started"]).toLocaleString('en-US', {
                      year: 'numeric',
                      month: 'short',
                      day: 'numeric',
                  })}` : "-"}</div>
              <div style={{ width: '80%', userSelect: 'none' }}>{row.Tittle? capitalization(row.Tittle): "-"}</div>
          </div>)}
      </div>  
  </>
  );
}

MobileAirtable.propTypes = {
  orderRow: PropTypes.arrayOf(PropTypes.obj),
};

MobileAirtable.defaultProps = {
  orderRow: [],
};

export default MobileAirtable;
